import { render, staticRenderFns } from "./landing-nav-buttons.vue?vue&type=template&id=86ec46f8"
import script from "./landing-nav-buttons.vue?vue&type=script&lang=js"
export * from "./landing-nav-buttons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports